import { render, staticRenderFns } from "./LinkPreviewCustom.vue?vue&type=template&id=f9edf9b8&scoped=true&"
import script from "./LinkPreviewCustom.vue?vue&type=script&lang=js&"
export * from "./LinkPreviewCustom.vue?vue&type=script&lang=js&"
import style0 from "./LinkPreviewCustom.vue?vue&type=style&index=0&id=f9edf9b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9edf9b8",
  null
  
)

export default component.exports